import { alpha } from '@mui/material';
import palette from './palette';
import { CustomShadowOptions } from '../shared-types/theme/shadows';

type Params = {
  color: string;
  isInset?: boolean;
};

export const createCustomShadow = ({
  color,
  isInset = false,
}: Params): CustomShadowOptions => {
  const shouldInset = isInset ? 'inset' : '';
  return {
    xs: `${shouldInset} 0 1px 2px 0 ${alpha(color, 0.05)}`,
    sm: `${shouldInset} 0 1px 2px -1px ${alpha(color, 0.1)}, 0 1px 3px 0 ${alpha(color, 0.1)}`,
    md: `${shouldInset} 0 2px 4px -2px ${alpha(color, 0.06)}, 0 4px 6px -1px ${alpha(color, 0.1)}`,
    lg: `${shouldInset}0 2px 2px -1px ${alpha(color, 0.04)}, 0 4px 6px -2px ${alpha(color, 0.03)}, 0 12px 16px -4px ${alpha(color, 0.08)}`,
    xl: `${shouldInset} 0 3px 3px -1.5px ${alpha(color, 0.04)}, 0 8px 8px -4px ${alpha(color, 0.03)}, 0 20px 24px -4px ${alpha(color, 0.08)}`,
    xxl: `${shouldInset} 0 4px 4px -2px ${alpha(color, 0.04)}, 0 24px 48px -12px ${alpha(color, 0.18)}`,
    xxxl: `${shouldInset} 0 5px 5px -2.5px ${alpha(color, 0.04)}, 0 32px 64px -12px ${alpha(color, 0.14)}`,
  };
};

export const customShadows = {
  light: createCustomShadow({ color: palette.light.grey[950] }),
  dark: createCustomShadow({ color: palette.light.grey[950] }), //? it seems like dark mode does not have a custom shadow we can set it up here later
};

export default customShadows;
